import React from "react";
import { FaDatabase, FaProjectDiagram, FaChartLine, FaBrain } from "react-icons/fa";

const features = [
  { 
    icon: <FaDatabase size={40} />, 
    title: "Data Integration", 
    desc: "Connect databases, APIs, and files into a unified data pipeline." 
  },
  { 
    icon: <FaProjectDiagram size={40} />, 
    title: "ETL Pipelines", 
    desc: "Transform and load data with automated, scalable ETL workflows." 
  },
  { 
    icon: <FaChartLine size={40} />, 
    title: "Data Visualization", 
    desc: "Generate dashboards and insights to understand your data easily." 
  },
  { 
    icon: <FaBrain size={40} />, 
    title: "AI Insights", 
    desc: "Leverage AI to predict trends and get intelligent recommendations." 
  }
];

const Features = () => (
  <section id="features" className="py-20 bg-[#f0f4ff] text-center px-6">
    <h2 className="text-3xl font-bold mb-12">Why Stackness?</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 max-w-6xl mx-auto">
      {features.map((f, i) => (
        <div
          key={i}
          data-aos="fade-up"
          className="p-6 bg-white rounded-2xl shadow hover:shadow-xl transition"
        >
          <div className="text-indigo-600 mb-4">{f.icon}</div>
          <h3 className="text-xl font-semibold mb-2">{f.title}</h3>
          <p className="text-sm text-gray-600">{f.desc}</p>
        </div>
      ))}
    </div>
  </section>
);

export default Features;
